<div class="ttmodal">
    <div class="ttmodal__header">
      <span class="ttmodal__title">Update Inspection Forcasting</span>
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i>
    </div>
    <div class="ttmodal__body">
      <div>How often will you be inspecting this equipment?</div>
      <div style="margin-top:8px; margin-bottom: 8px;">We will use this to forecast future inspections.</div>
      
      
    
          <mat-form-field class="input" style="width: 200px">
              <input matInput placeholder="{{'I will inspect every' | translate | async}}" type="number" [(ngModel)]="inspectEvery" [formControl]="changeInspectionEveryControl"
               ngDefaultControl required>
          </mat-form-field>
        
     
     
    

      
          <mat-form-field class="input" style="width: 200px">
              <mat-select placeholder="Job Site" [(ngModel)]="selectedEveryUnit" ngDefaultControl required>
                <mat-option [value]="unit.Id" *ngFor="let unit of unitList">
                  {{unit.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>        
      
    
      <div *ngIf="changeInspectionEveryControl.errors && (changeInspectionEveryControl.dirty || changeInspectionEveryControl.touched)" style="margin-bottom: 20px;">
          <mat-error *ngIf="changeInspectionEveryControl.errors.required">Time is required</mat-error>
      </div>  
    </div>
    <div class="ttmodal__footer">
      <button mat-raised-button (click)="onNoClick()">Cancel</button>
      <button mat-raised-button color="warn" [class.loading]="saving" [disabled]= "changeInspectionEveryControl.errors" (click)="updateInspectionForecastTime()"><span class="material-icons button__icon">check</span><span class="button__text">Update</span></button>
    </div>
  </div>
  